"use client";

import { useState } from "react";
import { useFormContext } from "react-hook-form";
import FormInputField from "@/components/custom-form/FormInputField";
import { Button } from "@/components/ui/button";
import { IconEye, IconEyeClosed, IconLock } from "@tabler/icons-react";

type CreatePasswordContentProps = {
  passwordValue?: string;
  confirmPasswordValue?: string;
  isSubmitting?: boolean;
  submitLabel?: string;
  onSubmit: (event?: React.BaseSyntheticEvent) => void;
};

const CreatePasswordContent = ({
  passwordValue = "",
  confirmPasswordValue = "",
  isSubmitting = false,
  submitLabel = "Create Account",
  onSubmit,
}: CreatePasswordContentProps) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const { control, watch } = useFormContext();

  const currentPassword = watch?.("password") ?? passwordValue;
  const currentConfirmPassword =
    watch?.("confirmPassword") ?? confirmPasswordValue;

  /**
   * Ticekt: V2CA-1286
   * Base on discussion Oct 7, 2026, Bong Ey suggest to remove strong password policy.
   * Problem (from mangement):
   * Customer feel complicated
   * Hard to understand
   */

  // const requirements = useMemo(() => {
  //   return [
  //     {
  //       id: "length",
  //       label: "Password must be at least 8 characters",
  //       isValid: currentPassword.length >= 8,
  //     },
  //     {
  //       id: "uppercase",
  //       label: "Password must contain uppercase letters",
  //       isValid: /[A-Z]/.test(currentPassword),
  //     },
  //     {
  //       id: "number",
  //       label: "Password must contain numbers",
  //       isValid: /[0-9]/.test(currentPassword),
  //     },
  //     {
  //       id: "symbol",
  //       label: "Password must have at least one symbol",
  //       isValid: /[\W_]/.test(currentPassword),
  //     },
  //   ];
  // }, [currentPassword]);

  // const allValid = requirements.every((req) => req.isValid);

  return (
    <div className="flex w-full flex-col px-4 md:pb-0 pb-10">
      <form onSubmit={onSubmit} className="flex flex-col gap-4 pt-1">
        <FormInputField
          control={control}
          name="password"
          type={showPassword ? "text" : "password"}
          label="Password"
          placeholder="Password"
          leadingIcon={<IconLock className="h-5 w-5" stroke={1.8} />}
          trailingIcon={
            <button
              type="button"
              onClick={() => setShowPassword((prev) => !prev)}
              className="flex items-center text-body hover:text-heading"
            >
              {showPassword ? (
                <IconEye className="h-5 w-5" stroke={1.8} />
              ) : (
                <IconEyeClosed className="h-5 w-5" stroke={1.8} />
              )}
            </button>
          }
        />

        <FormInputField
          control={control}
          name="confirmPassword"
          type={showConfirmPassword ? "text" : "password"}
          label="Confirm Password"
          placeholder="Re-enter Password"
          leadingIcon={<IconLock className="h-5 w-5" stroke={1.8} />}
          trailingIcon={
            <button
              type="button"
              onClick={() => setShowConfirmPassword((prev) => !prev)}
              className="flex items-center text-body hover:text-heading"
            >
              {showConfirmPassword ? (
                <IconEye className="h-5 w-5" stroke={1.8} />
              ) : (
                <IconEyeClosed className="h-5 w-5" stroke={1.8} />
              )}
            </button>
          }
        />

        {/* <div className="mt-1 flex flex-col gap-[10px] px-1">
          {requirements.map((req) => (
            <div key={req.id} className="flex items-center gap-2">
              {req.isValid ? (
                <IconCheck size={18} stroke={2} className="text-[#2B8A3E]" />
              ) : (
                <IconX size={18} stroke={2} className="text-[#464C53]" />
              )}
              <span
                className={`text-[13px] font-medium leading-[13px] ${req.isValid ? "text-[#2B8A3E]" : "text-[#464C53]"
                  }`}
              >
                {req.label}
              </span>
            </div>
          ))}
        </div> */}

        <Button
          type="submit"
          size="xl"
          isLoading={isSubmitting}
          disabled={!currentPassword || !currentConfirmPassword || isSubmitting}
          className="mt-2"
        >
          {submitLabel}
        </Button>
      </form>
    </div>
  );
};

export default CreatePasswordContent;
